module.exports = __webpack_public_path__ + "assets/img/two-tab4-on.8e866099.png";